import * as React from 'react'
import { WalletDto } from 'api/Wallet/Types/Wallet'

import { TradingAccountTable } from './WalletTradingAccountTable'

import './Wallets.scss'

interface Props {
  data: WalletDto
}
const WalletDetailsTradingAccounts: React.FC<Props> = ({ data }) => (
  <TradingAccountTable data={data} />
)

export default WalletDetailsTradingAccounts
